import { Grid } from "@mui/material";
import InputGroup from "../../../components/FormComponent/InputGroup";
import styles from "../settings.module.css";
import SelectGroup from "../../../components/FormComponent/SelectGroup";

import { useEffect, useState } from "react";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import PageLoader from "../../../components/PageLoader";
import Button from "../../../components/Button";
import Layout from "../../../components/Layout";
import BreadCrumb from "../../../components/BreadCrumb";
import { useNavigate, useParams } from "react-router-dom";

const ROLE_ENDPOINT = "/api/v1/roles";
const ALL_PERMISSIONS = "/api/v1/permissions";

const UpdateRole = () => {
  const [roles, setRoles] = useState(null);
  const [roleType, setRoleType] = useState("");
  const [roleNameValue, setRoleNameValue] = useState("");
  const [selectedPermission, setSelectedPermission] = useState([]);
  const [allPermissions, setAllPermissions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  // Get All roles
  const getRoles = () => {
    httprequest
      .get(`${ROLE_ENDPOINT}/${id}`)
      .then((res) => {
        const roleData = res?.data?.data;
        setRoleNameValue(roleData?.role_name);
        setRoleType(roleData?.role_type);
        const permissionNames = roleData?.permissions;
        setSelectedPermission(permissionNames);
        setRoles(roleData);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  // Get All Permissions
  const getPermissions = () => {
    setIsLoading(true);
    httprequest
      .get(ALL_PERMISSIONS)
      .then((res) => {
        setIsLoading(false);
        setAllPermissions(res?.data?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  useEffect(() => {
    getRoles();
    getPermissions();
  }, []);

  const handleRoleNameChange = (e) => {
    setRoleNameValue(e.target.value);
  };

  const isPermissionChecked = (permissionName) => {
    return selectedPermission?.includes(permissionName) || false;
  };

  /**
   * Fetches permissions for the selected role and updates the state.
   * @returns {void}
   */
  const getRolePermissions = () => {
    httprequest.get(`${ROLE_ENDPOINT}/${id}`).then((res) => {
      const permissionsList = res?.data?.data?.permissions;
      setSelectedPermission(permissionsList);
    }).catch((err) => {
      toast.error(err?.res?.message);
    });
  };

  useEffect(() => {
    if (roles) {
      setIsLoading(false);
      getRolePermissions(roles.role_id);
    }
  }, [roleType, roles]);
  /**
   * Handles the change of permission checkboxes.
   * Toggles the selection of a permission based on its name.
   * @param {*} permissionName - The name of the permission to toggle.
   * @returns {void}
   */
  const handleCheckChange = (permissionName) => {
    setSelectedPermission((prev) => {
      const updatedPermissions = prev?.includes(permissionName)
        ? prev.filter((perm) => perm !== permissionName)
        : [...(prev || []), permissionName];

      return updatedPermissions;
    });
  };
  /**
 * Handles the update role form submission.
 * Validates the form and sends a PATCH request to update the role.
 */
  const handleUpdateRole = () => {
    const updatedRoleData = {
      role_name: roleNameValue,
      role_type: roleType,
      permissions: selectedPermission
    };

    httprequest
      .patch(`${ROLE_ENDPOINT}/${id}`, updatedRoleData)
      .then((res) => {
        toast.success(res?.data?.message);
        setTimeout(() => {
          navigate("/settings");
        }, 1500);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container" style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <BreadCrumb
                link_one="/settings"
                link_one_name="Settings"
                active="Update Role"
                description={
                  <>
                    <div>Update Roles and Permissions in your organisation.</div>
                  </>
                }
              />
            </div>
          </div>

          <div className={`${styles.allcontent}`}>
            <div style={{ marginBottom: "1rem", background: "white", padding: "0.6rem 1rem", borderRadius: "8px" }}>
              <Grid className="input-padding" container spacing={2}>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <InputGroup
                    label="Role Name"
                    margin="normal"
                    placeHolder="Edit the role name"
                    inputType="text"
                    disabled="disabled"
                    onChange={handleRoleNameChange}
                    value={roleNameValue}
                  />
                </Grid>
              </Grid>
              <Grid className="input-padding margin-bottom" container spacing={2}>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <SelectGroup label="Role Type">
                    <select disabled value={roleType} onChange={(e) => setRoleType(e.target.value)}>
                      <option value="">--- Select Role Type ---</option>
                      <option key={roles?.role_id} value={roles?.role_type}>
                        {roles?.role_name}
                      </option>
                    </select>
                  </SelectGroup>
                </Grid>
              </Grid>
            </div>

            {isLoading ? (
              <PageLoader />
            ) : (
              <div className="text-align" style={{ background: "white", padding: "1rem 0", borderRadius: "8px" }}>
                {allPermissions?.map((sections, i) => {
                  return (
                    <div className={`${styles.optioninput} margin-bottom`} key={i}>
                      <h4 className={`${styles.people}`}>{sections?.section}</h4>
                      <Grid container spacing={2}>
                        {sections?.permissions?.map((list) => (
                          <Grid item lg={3} md={6} sm={6} xs={12} key={list?.permission_name}>
                            <div className={`${styles.picks} flex align-items-center`}>
                              <input
                                type="checkbox"
                                id={list?.permission_name}
                                onChange={() => handleCheckChange(list?.permission_name)}
                                checked={isPermissionChecked(list?.permission_name)}
                              />
                              <p>{list?.permission_description}</p>
                            </div>
                          </Grid>
                        ))}
                      </Grid>
                    </div>
                  );
                })}

                <div style={{ margin: "1rem" }} className="flex gap-10">
                  <Button variant="primary" buttonSize="fluid" color="btndefault" buttonName="Update Role" onClick={handleUpdateRole} />
                </div>

                {/* <ToastContainer /> */}
              </div>
            )}
          </div>
        </>
      }
    />
  );
};

export default UpdateRole;
